<div [class.p-4]="!dialogRef">
  <h4 mat-dialog-title>
    <span *ngIf="!agenzia?.id;else editHeader">
      Creazione nuova agenzia
    </span>
    <ng-template #editHeader>
      Modifica agenzia {{agenzia.nome}}
    </ng-template>
  </h4>

  <form *ngIf="form" [formGroup]="form" class="mt-4" (keydown.enter)="edit()">

    <mat-form-field>
      <mat-label>Nome</mat-label>
      <input matInput formControlName="nome">
    </mat-form-field>
    <mat-form-field>
      <mat-label>Codice</mat-label>
      <input matInput formControlName="codice">
    </mat-form-field>

    <mat-form-field *ngIf="!agenzia?.id"
      matTooltip="Se si riempie questo campo, l'agenzia verrà automaticamente collegata con la compagnia selezionata">
      <mat-label>
        Compagnia
      </mat-label>
      <compagnia-picker formControlName="compagnia"></compagnia-picker>
    </mat-form-field>
    <mat-form-field>

      <mat-label>
        Via / piazza
      </mat-label>
      <input matInput formControlName="via">
    </mat-form-field>

    <mat-form-field>
      <mat-label>
        N. civico
      </mat-label>
      <input matInput formControlName="civico">
    </mat-form-field>

    <mat-form-field>
      <mat-label>
        Comune
      </mat-label>
      <comune-picker formControlName="comune"></comune-picker>
    </mat-form-field>
    <mat-form-field>
      <mat-label>
        Telefono
      </mat-label>
      <input matInput formControlName="tel">
    </mat-form-field>
    <mat-form-field>
      <mat-label>
        Cellulare
      </mat-label>
      <input matInput formControlName="cell">
    </mat-form-field>
    <mat-form-field>
      <mat-label>
        Fax
      </mat-label>
      <input matInput formControlName="fax">
    </mat-form-field>
    <mat-form-field>
      <mat-label>
        Email
      </mat-label>
      <input matInput formControlName="email">
    </mat-form-field>
  </form>
  <button mat-raised-button (click)="edit()" color="primary">Salva</button>

</div>